import { RepeatPasswordField } from './components/RepeatPasswordField';

export const CHANGE_PASSWORD_COMPONENTS_MAP = {
  REPEAT_PASSWORD: 'repeat-password'
};

export const stepComponentsMap = {
  [CHANGE_PASSWORD_COMPONENTS_MAP.REPEAT_PASSWORD]: RepeatPasswordField
};
